/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordSuccessfulRouteImport } from './routes/reset-password-successful'
import { Route as ResetPasswordExpiredRouteImport } from './routes/reset-password-expired'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedCompanySlugRouteImport } from './routes/_authenticated/$companySlug'
import { Route as AuthenticatedCompanySlugUserSettingsRouteImport } from './routes/_authenticated/$companySlug/user-settings'
import { Route as AuthenticatedCompanySlugNotificationCenterRouteRouteImport } from './routes/_authenticated/$companySlug/notification-center/route'
import { Route as AuthenticatedCompanySlugVehiclesIndexRouteImport } from './routes/_authenticated/$companySlug/vehicles/index'
import { Route as AuthenticatedCompanySlugUsersOldIndexRouteImport } from './routes/_authenticated/$companySlug/users-old/index'
import { Route as AuthenticatedCompanySlugRoutePlanningIndexRouteImport } from './routes/_authenticated/$companySlug/route-planning/index'
import { Route as AuthenticatedCompanySlugReportsIndexRouteImport } from './routes/_authenticated/$companySlug/reports/index'
import { Route as AuthenticatedCompanySlugMarketplaceIndexRouteImport } from './routes/_authenticated/$companySlug/marketplace/index'
import { Route as AuthenticatedCompanySlugFleetTrackingIndexRouteImport } from './routes/_authenticated/$companySlug/fleet-tracking/index'
import { Route as AuthenticatedCompanySlugFleetAllocationIndexRouteImport } from './routes/_authenticated/$companySlug/fleet-allocation/index'
import { Route as AuthenticatedCompanySlugDashboardIndexRouteImport } from './routes/_authenticated/$companySlug/dashboard/index'
import { Route as AuthenticatedCompanySlugChargingInfrastructureIndexRouteImport } from './routes/_authenticated/$companySlug/charging-infrastructure/index'
import { Route as AuthenticatedCompanySlugAdministrationIndexRouteImport } from './routes/_authenticated/$companySlug/administration/index'
import { Route as AuthenticatedCompanySlugVehiclesCreateRouteImport } from './routes/_authenticated/$companySlug/vehicles/create'
import { Route as AuthenticatedCompanySlugUsersCreateRouteImport } from './routes/_authenticated/$companySlug/users/create'
import { Route as AuthenticatedCompanySlugRoutePlanningImportRouteImport } from './routes/_authenticated/$companySlug/route-planning/import'
import { Route as AuthenticatedCompanySlugRoutePlanningAssignmentRouteImport } from './routes/_authenticated/$companySlug/route-planning/assignment'
import { Route as AuthenticatedCompanySlugReportsImportRouteImport } from './routes/_authenticated/$companySlug/reports/import'
import { Route as AuthenticatedCompanySlugNotificationCenterAlertIdRouteImport } from './routes/_authenticated/$companySlug/notification-center/$alertId'
import { Route as AuthenticatedCompanySlugFleetsFleetIdRouteImport } from './routes/_authenticated/$companySlug/fleets/$fleetId'
import { Route as AuthenticatedCompanySlugUsersOverviewRouteRouteImport } from './routes/_authenticated/$companySlug/users/_overview/route'
import { Route as AuthenticatedCompanySlugVehiclesVinIndexRouteImport } from './routes/_authenticated/$companySlug/vehicles/$vin/index'
import { Route as AuthenticatedCompanySlugVehiclesVinUpdateRouteImport } from './routes/_authenticated/$companySlug/vehicles/$vin/update'
import { Route as AuthenticatedCompanySlugUsersOverviewUserIdRouteImport } from './routes/_authenticated/$companySlug/users/_overview/$userId'
import { Route as AuthenticatedCompanySlugUsersUserIdEditRouteImport } from './routes/_authenticated/$companySlug/users/$userId/edit'
import { Route as AuthenticatedCompanySlugReportsEditReportIdRouteImport } from './routes/_authenticated/$companySlug/reports/edit/$reportId'
import { Route as AuthenticatedCompanySlugChargingInfrastructureSiteIdTerminalsChargeTerminalIdRouteImport } from './routes/_authenticated/$companySlug/charging-infrastructure/$siteId/terminals/$chargeTerminalId'

const ResetPasswordSuccessfulRoute = ResetPasswordSuccessfulRouteImport.update({
  id: '/reset-password-successful',
  path: '/reset-password-successful',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordExpiredRoute = ResetPasswordExpiredRouteImport.update({
  id: '/reset-password-expired',
  path: '/reset-password-expired',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompanySlugRoute =
  AuthenticatedCompanySlugRouteImport.update({
    id: '/$companySlug',
    path: '/$companySlug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompanySlugUserSettingsRoute =
  AuthenticatedCompanySlugUserSettingsRouteImport.update({
    id: '/user-settings',
    path: '/user-settings',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugNotificationCenterRouteRoute =
  AuthenticatedCompanySlugNotificationCenterRouteRouteImport.update({
    id: '/notification-center',
    path: '/notification-center',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugVehiclesIndexRoute =
  AuthenticatedCompanySlugVehiclesIndexRouteImport.update({
    id: '/vehicles/',
    path: '/vehicles/',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugUsersOldIndexRoute =
  AuthenticatedCompanySlugUsersOldIndexRouteImport.update({
    id: '/users-old/',
    path: '/users-old/',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugRoutePlanningIndexRoute =
  AuthenticatedCompanySlugRoutePlanningIndexRouteImport.update({
    id: '/route-planning/',
    path: '/route-planning/',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugReportsIndexRoute =
  AuthenticatedCompanySlugReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugMarketplaceIndexRoute =
  AuthenticatedCompanySlugMarketplaceIndexRouteImport.update({
    id: '/marketplace/',
    path: '/marketplace/',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugFleetTrackingIndexRoute =
  AuthenticatedCompanySlugFleetTrackingIndexRouteImport.update({
    id: '/fleet-tracking/',
    path: '/fleet-tracking/',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugFleetAllocationIndexRoute =
  AuthenticatedCompanySlugFleetAllocationIndexRouteImport.update({
    id: '/fleet-allocation/',
    path: '/fleet-allocation/',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugDashboardIndexRoute =
  AuthenticatedCompanySlugDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugChargingInfrastructureIndexRoute =
  AuthenticatedCompanySlugChargingInfrastructureIndexRouteImport.update({
    id: '/charging-infrastructure/',
    path: '/charging-infrastructure/',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugAdministrationIndexRoute =
  AuthenticatedCompanySlugAdministrationIndexRouteImport.update({
    id: '/administration/',
    path: '/administration/',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugVehiclesCreateRoute =
  AuthenticatedCompanySlugVehiclesCreateRouteImport.update({
    id: '/vehicles/create',
    path: '/vehicles/create',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugUsersCreateRoute =
  AuthenticatedCompanySlugUsersCreateRouteImport.update({
    id: '/users/create',
    path: '/users/create',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugRoutePlanningImportRoute =
  AuthenticatedCompanySlugRoutePlanningImportRouteImport.update({
    id: '/route-planning/import',
    path: '/route-planning/import',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugRoutePlanningAssignmentRoute =
  AuthenticatedCompanySlugRoutePlanningAssignmentRouteImport.update({
    id: '/route-planning/assignment',
    path: '/route-planning/assignment',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugReportsImportRoute =
  AuthenticatedCompanySlugReportsImportRouteImport.update({
    id: '/reports/import',
    path: '/reports/import',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugNotificationCenterAlertIdRoute =
  AuthenticatedCompanySlugNotificationCenterAlertIdRouteImport.update({
    id: '/$alertId',
    path: '/$alertId',
    getParentRoute: () => AuthenticatedCompanySlugNotificationCenterRouteRoute,
  } as any)
const AuthenticatedCompanySlugFleetsFleetIdRoute =
  AuthenticatedCompanySlugFleetsFleetIdRouteImport.update({
    id: '/fleets/$fleetId',
    path: '/fleets/$fleetId',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugUsersOverviewRouteRoute =
  AuthenticatedCompanySlugUsersOverviewRouteRouteImport.update({
    id: '/users/_overview',
    path: '/users',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugVehiclesVinIndexRoute =
  AuthenticatedCompanySlugVehiclesVinIndexRouteImport.update({
    id: '/vehicles/$vin/',
    path: '/vehicles/$vin/',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugVehiclesVinUpdateRoute =
  AuthenticatedCompanySlugVehiclesVinUpdateRouteImport.update({
    id: '/vehicles/$vin/update',
    path: '/vehicles/$vin/update',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugUsersOverviewUserIdRoute =
  AuthenticatedCompanySlugUsersOverviewUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AuthenticatedCompanySlugUsersOverviewRouteRoute,
  } as any)
const AuthenticatedCompanySlugUsersUserIdEditRoute =
  AuthenticatedCompanySlugUsersUserIdEditRouteImport.update({
    id: '/users/$userId/edit',
    path: '/users/$userId/edit',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugReportsEditReportIdRoute =
  AuthenticatedCompanySlugReportsEditReportIdRouteImport.update({
    id: '/reports/edit/$reportId',
    path: '/reports/edit/$reportId',
    getParentRoute: () => AuthenticatedCompanySlugRoute,
  } as any)
const AuthenticatedCompanySlugChargingInfrastructureSiteIdTerminalsChargeTerminalIdRoute =
  AuthenticatedCompanySlugChargingInfrastructureSiteIdTerminalsChargeTerminalIdRouteImport.update(
    {
      id: '/charging-infrastructure/$siteId/terminals/$chargeTerminalId',
      path: '/charging-infrastructure/$siteId/terminals/$chargeTerminalId',
      getParentRoute: () => AuthenticatedCompanySlugRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/activate': typeof ActivateRoute
  '/forbidden': typeof ForbiddenRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/reset-password-expired': typeof ResetPasswordExpiredRoute
  '/reset-password-successful': typeof ResetPasswordSuccessfulRoute
  '/$companySlug': typeof AuthenticatedCompanySlugRouteWithChildren
  '/$companySlug/notification-center': typeof AuthenticatedCompanySlugNotificationCenterRouteRouteWithChildren
  '/$companySlug/user-settings': typeof AuthenticatedCompanySlugUserSettingsRoute
  '/$companySlug/users': typeof AuthenticatedCompanySlugUsersOverviewRouteRouteWithChildren
  '/$companySlug/fleets/$fleetId': typeof AuthenticatedCompanySlugFleetsFleetIdRoute
  '/$companySlug/notification-center/$alertId': typeof AuthenticatedCompanySlugNotificationCenterAlertIdRoute
  '/$companySlug/reports/import': typeof AuthenticatedCompanySlugReportsImportRoute
  '/$companySlug/route-planning/assignment': typeof AuthenticatedCompanySlugRoutePlanningAssignmentRoute
  '/$companySlug/route-planning/import': typeof AuthenticatedCompanySlugRoutePlanningImportRoute
  '/$companySlug/users/create': typeof AuthenticatedCompanySlugUsersCreateRoute
  '/$companySlug/vehicles/create': typeof AuthenticatedCompanySlugVehiclesCreateRoute
  '/$companySlug/administration/': typeof AuthenticatedCompanySlugAdministrationIndexRoute
  '/$companySlug/charging-infrastructure/': typeof AuthenticatedCompanySlugChargingInfrastructureIndexRoute
  '/$companySlug/dashboard/': typeof AuthenticatedCompanySlugDashboardIndexRoute
  '/$companySlug/fleet-allocation/': typeof AuthenticatedCompanySlugFleetAllocationIndexRoute
  '/$companySlug/fleet-tracking/': typeof AuthenticatedCompanySlugFleetTrackingIndexRoute
  '/$companySlug/marketplace/': typeof AuthenticatedCompanySlugMarketplaceIndexRoute
  '/$companySlug/reports/': typeof AuthenticatedCompanySlugReportsIndexRoute
  '/$companySlug/route-planning/': typeof AuthenticatedCompanySlugRoutePlanningIndexRoute
  '/$companySlug/users-old/': typeof AuthenticatedCompanySlugUsersOldIndexRoute
  '/$companySlug/vehicles/': typeof AuthenticatedCompanySlugVehiclesIndexRoute
  '/$companySlug/reports/edit/$reportId': typeof AuthenticatedCompanySlugReportsEditReportIdRoute
  '/$companySlug/users/$userId/edit': typeof AuthenticatedCompanySlugUsersUserIdEditRoute
  '/$companySlug/users/$userId': typeof AuthenticatedCompanySlugUsersOverviewUserIdRoute
  '/$companySlug/vehicles/$vin/update': typeof AuthenticatedCompanySlugVehiclesVinUpdateRoute
  '/$companySlug/vehicles/$vin/': typeof AuthenticatedCompanySlugVehiclesVinIndexRoute
  '/$companySlug/charging-infrastructure/$siteId/terminals/$chargeTerminalId': typeof AuthenticatedCompanySlugChargingInfrastructureSiteIdTerminalsChargeTerminalIdRoute
}
export interface FileRoutesByTo {
  '/activate': typeof ActivateRoute
  '/forbidden': typeof ForbiddenRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/reset-password-expired': typeof ResetPasswordExpiredRoute
  '/reset-password-successful': typeof ResetPasswordSuccessfulRoute
  '/$companySlug': typeof AuthenticatedCompanySlugRouteWithChildren
  '/': typeof AuthenticatedIndexRoute
  '/$companySlug/notification-center': typeof AuthenticatedCompanySlugNotificationCenterRouteRouteWithChildren
  '/$companySlug/user-settings': typeof AuthenticatedCompanySlugUserSettingsRoute
  '/$companySlug/users': typeof AuthenticatedCompanySlugUsersOverviewRouteRouteWithChildren
  '/$companySlug/fleets/$fleetId': typeof AuthenticatedCompanySlugFleetsFleetIdRoute
  '/$companySlug/notification-center/$alertId': typeof AuthenticatedCompanySlugNotificationCenterAlertIdRoute
  '/$companySlug/reports/import': typeof AuthenticatedCompanySlugReportsImportRoute
  '/$companySlug/route-planning/assignment': typeof AuthenticatedCompanySlugRoutePlanningAssignmentRoute
  '/$companySlug/route-planning/import': typeof AuthenticatedCompanySlugRoutePlanningImportRoute
  '/$companySlug/users/create': typeof AuthenticatedCompanySlugUsersCreateRoute
  '/$companySlug/vehicles/create': typeof AuthenticatedCompanySlugVehiclesCreateRoute
  '/$companySlug/administration': typeof AuthenticatedCompanySlugAdministrationIndexRoute
  '/$companySlug/charging-infrastructure': typeof AuthenticatedCompanySlugChargingInfrastructureIndexRoute
  '/$companySlug/dashboard': typeof AuthenticatedCompanySlugDashboardIndexRoute
  '/$companySlug/fleet-allocation': typeof AuthenticatedCompanySlugFleetAllocationIndexRoute
  '/$companySlug/fleet-tracking': typeof AuthenticatedCompanySlugFleetTrackingIndexRoute
  '/$companySlug/marketplace': typeof AuthenticatedCompanySlugMarketplaceIndexRoute
  '/$companySlug/reports': typeof AuthenticatedCompanySlugReportsIndexRoute
  '/$companySlug/route-planning': typeof AuthenticatedCompanySlugRoutePlanningIndexRoute
  '/$companySlug/users-old': typeof AuthenticatedCompanySlugUsersOldIndexRoute
  '/$companySlug/vehicles': typeof AuthenticatedCompanySlugVehiclesIndexRoute
  '/$companySlug/reports/edit/$reportId': typeof AuthenticatedCompanySlugReportsEditReportIdRoute
  '/$companySlug/users/$userId/edit': typeof AuthenticatedCompanySlugUsersUserIdEditRoute
  '/$companySlug/users/$userId': typeof AuthenticatedCompanySlugUsersOverviewUserIdRoute
  '/$companySlug/vehicles/$vin/update': typeof AuthenticatedCompanySlugVehiclesVinUpdateRoute
  '/$companySlug/vehicles/$vin': typeof AuthenticatedCompanySlugVehiclesVinIndexRoute
  '/$companySlug/charging-infrastructure/$siteId/terminals/$chargeTerminalId': typeof AuthenticatedCompanySlugChargingInfrastructureSiteIdTerminalsChargeTerminalIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/activate': typeof ActivateRoute
  '/forbidden': typeof ForbiddenRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/reset-password-expired': typeof ResetPasswordExpiredRoute
  '/reset-password-successful': typeof ResetPasswordSuccessfulRoute
  '/_authenticated/$companySlug': typeof AuthenticatedCompanySlugRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$companySlug/notification-center': typeof AuthenticatedCompanySlugNotificationCenterRouteRouteWithChildren
  '/_authenticated/$companySlug/user-settings': typeof AuthenticatedCompanySlugUserSettingsRoute
  '/_authenticated/$companySlug/users/_overview': typeof AuthenticatedCompanySlugUsersOverviewRouteRouteWithChildren
  '/_authenticated/$companySlug/fleets/$fleetId': typeof AuthenticatedCompanySlugFleetsFleetIdRoute
  '/_authenticated/$companySlug/notification-center/$alertId': typeof AuthenticatedCompanySlugNotificationCenterAlertIdRoute
  '/_authenticated/$companySlug/reports/import': typeof AuthenticatedCompanySlugReportsImportRoute
  '/_authenticated/$companySlug/route-planning/assignment': typeof AuthenticatedCompanySlugRoutePlanningAssignmentRoute
  '/_authenticated/$companySlug/route-planning/import': typeof AuthenticatedCompanySlugRoutePlanningImportRoute
  '/_authenticated/$companySlug/users/create': typeof AuthenticatedCompanySlugUsersCreateRoute
  '/_authenticated/$companySlug/vehicles/create': typeof AuthenticatedCompanySlugVehiclesCreateRoute
  '/_authenticated/$companySlug/administration/': typeof AuthenticatedCompanySlugAdministrationIndexRoute
  '/_authenticated/$companySlug/charging-infrastructure/': typeof AuthenticatedCompanySlugChargingInfrastructureIndexRoute
  '/_authenticated/$companySlug/dashboard/': typeof AuthenticatedCompanySlugDashboardIndexRoute
  '/_authenticated/$companySlug/fleet-allocation/': typeof AuthenticatedCompanySlugFleetAllocationIndexRoute
  '/_authenticated/$companySlug/fleet-tracking/': typeof AuthenticatedCompanySlugFleetTrackingIndexRoute
  '/_authenticated/$companySlug/marketplace/': typeof AuthenticatedCompanySlugMarketplaceIndexRoute
  '/_authenticated/$companySlug/reports/': typeof AuthenticatedCompanySlugReportsIndexRoute
  '/_authenticated/$companySlug/route-planning/': typeof AuthenticatedCompanySlugRoutePlanningIndexRoute
  '/_authenticated/$companySlug/users-old/': typeof AuthenticatedCompanySlugUsersOldIndexRoute
  '/_authenticated/$companySlug/vehicles/': typeof AuthenticatedCompanySlugVehiclesIndexRoute
  '/_authenticated/$companySlug/reports/edit/$reportId': typeof AuthenticatedCompanySlugReportsEditReportIdRoute
  '/_authenticated/$companySlug/users/$userId/edit': typeof AuthenticatedCompanySlugUsersUserIdEditRoute
  '/_authenticated/$companySlug/users/_overview/$userId': typeof AuthenticatedCompanySlugUsersOverviewUserIdRoute
  '/_authenticated/$companySlug/vehicles/$vin/update': typeof AuthenticatedCompanySlugVehiclesVinUpdateRoute
  '/_authenticated/$companySlug/vehicles/$vin/': typeof AuthenticatedCompanySlugVehiclesVinIndexRoute
  '/_authenticated/$companySlug/charging-infrastructure/$siteId/terminals/$chargeTerminalId': typeof AuthenticatedCompanySlugChargingInfrastructureSiteIdTerminalsChargeTerminalIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/forbidden'
    | '/forgot-password'
    | '/login'
    | '/not-found'
    | '/reset-password'
    | '/reset-password-expired'
    | '/reset-password-successful'
    | '/$companySlug'
    | '/$companySlug/notification-center'
    | '/$companySlug/user-settings'
    | '/$companySlug/users'
    | '/$companySlug/fleets/$fleetId'
    | '/$companySlug/notification-center/$alertId'
    | '/$companySlug/reports/import'
    | '/$companySlug/route-planning/assignment'
    | '/$companySlug/route-planning/import'
    | '/$companySlug/users/create'
    | '/$companySlug/vehicles/create'
    | '/$companySlug/administration/'
    | '/$companySlug/charging-infrastructure/'
    | '/$companySlug/dashboard/'
    | '/$companySlug/fleet-allocation/'
    | '/$companySlug/fleet-tracking/'
    | '/$companySlug/marketplace/'
    | '/$companySlug/reports/'
    | '/$companySlug/route-planning/'
    | '/$companySlug/users-old/'
    | '/$companySlug/vehicles/'
    | '/$companySlug/reports/edit/$reportId'
    | '/$companySlug/users/$userId/edit'
    | '/$companySlug/users/$userId'
    | '/$companySlug/vehicles/$vin/update'
    | '/$companySlug/vehicles/$vin/'
    | '/$companySlug/charging-infrastructure/$siteId/terminals/$chargeTerminalId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/activate'
    | '/forbidden'
    | '/forgot-password'
    | '/login'
    | '/not-found'
    | '/reset-password'
    | '/reset-password-expired'
    | '/reset-password-successful'
    | '/$companySlug'
    | '/'
    | '/$companySlug/notification-center'
    | '/$companySlug/user-settings'
    | '/$companySlug/users'
    | '/$companySlug/fleets/$fleetId'
    | '/$companySlug/notification-center/$alertId'
    | '/$companySlug/reports/import'
    | '/$companySlug/route-planning/assignment'
    | '/$companySlug/route-planning/import'
    | '/$companySlug/users/create'
    | '/$companySlug/vehicles/create'
    | '/$companySlug/administration'
    | '/$companySlug/charging-infrastructure'
    | '/$companySlug/dashboard'
    | '/$companySlug/fleet-allocation'
    | '/$companySlug/fleet-tracking'
    | '/$companySlug/marketplace'
    | '/$companySlug/reports'
    | '/$companySlug/route-planning'
    | '/$companySlug/users-old'
    | '/$companySlug/vehicles'
    | '/$companySlug/reports/edit/$reportId'
    | '/$companySlug/users/$userId/edit'
    | '/$companySlug/users/$userId'
    | '/$companySlug/vehicles/$vin/update'
    | '/$companySlug/vehicles/$vin'
    | '/$companySlug/charging-infrastructure/$siteId/terminals/$chargeTerminalId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/activate'
    | '/forbidden'
    | '/forgot-password'
    | '/login'
    | '/not-found'
    | '/reset-password'
    | '/reset-password-expired'
    | '/reset-password-successful'
    | '/_authenticated/$companySlug'
    | '/_authenticated/'
    | '/_authenticated/$companySlug/notification-center'
    | '/_authenticated/$companySlug/user-settings'
    | '/_authenticated/$companySlug/users/_overview'
    | '/_authenticated/$companySlug/fleets/$fleetId'
    | '/_authenticated/$companySlug/notification-center/$alertId'
    | '/_authenticated/$companySlug/reports/import'
    | '/_authenticated/$companySlug/route-planning/assignment'
    | '/_authenticated/$companySlug/route-planning/import'
    | '/_authenticated/$companySlug/users/create'
    | '/_authenticated/$companySlug/vehicles/create'
    | '/_authenticated/$companySlug/administration/'
    | '/_authenticated/$companySlug/charging-infrastructure/'
    | '/_authenticated/$companySlug/dashboard/'
    | '/_authenticated/$companySlug/fleet-allocation/'
    | '/_authenticated/$companySlug/fleet-tracking/'
    | '/_authenticated/$companySlug/marketplace/'
    | '/_authenticated/$companySlug/reports/'
    | '/_authenticated/$companySlug/route-planning/'
    | '/_authenticated/$companySlug/users-old/'
    | '/_authenticated/$companySlug/vehicles/'
    | '/_authenticated/$companySlug/reports/edit/$reportId'
    | '/_authenticated/$companySlug/users/$userId/edit'
    | '/_authenticated/$companySlug/users/_overview/$userId'
    | '/_authenticated/$companySlug/vehicles/$vin/update'
    | '/_authenticated/$companySlug/vehicles/$vin/'
    | '/_authenticated/$companySlug/charging-infrastructure/$siteId/terminals/$chargeTerminalId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ActivateRoute: typeof ActivateRoute
  ForbiddenRoute: typeof ForbiddenRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  NotFoundRoute: typeof NotFoundRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ResetPasswordExpiredRoute: typeof ResetPasswordExpiredRoute
  ResetPasswordSuccessfulRoute: typeof ResetPasswordSuccessfulRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password-successful': {
      id: '/reset-password-successful'
      path: '/reset-password-successful'
      fullPath: '/reset-password-successful'
      preLoaderRoute: typeof ResetPasswordSuccessfulRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password-expired': {
      id: '/reset-password-expired'
      path: '/reset-password-expired'
      fullPath: '/reset-password-expired'
      preLoaderRoute: typeof ResetPasswordExpiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$companySlug': {
      id: '/_authenticated/$companySlug'
      path: '/$companySlug'
      fullPath: '/$companySlug'
      preLoaderRoute: typeof AuthenticatedCompanySlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$companySlug/user-settings': {
      id: '/_authenticated/$companySlug/user-settings'
      path: '/user-settings'
      fullPath: '/$companySlug/user-settings'
      preLoaderRoute: typeof AuthenticatedCompanySlugUserSettingsRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/notification-center': {
      id: '/_authenticated/$companySlug/notification-center'
      path: '/notification-center'
      fullPath: '/$companySlug/notification-center'
      preLoaderRoute: typeof AuthenticatedCompanySlugNotificationCenterRouteRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/vehicles/': {
      id: '/_authenticated/$companySlug/vehicles/'
      path: '/vehicles'
      fullPath: '/$companySlug/vehicles/'
      preLoaderRoute: typeof AuthenticatedCompanySlugVehiclesIndexRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/users-old/': {
      id: '/_authenticated/$companySlug/users-old/'
      path: '/users-old'
      fullPath: '/$companySlug/users-old/'
      preLoaderRoute: typeof AuthenticatedCompanySlugUsersOldIndexRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/route-planning/': {
      id: '/_authenticated/$companySlug/route-planning/'
      path: '/route-planning'
      fullPath: '/$companySlug/route-planning/'
      preLoaderRoute: typeof AuthenticatedCompanySlugRoutePlanningIndexRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/reports/': {
      id: '/_authenticated/$companySlug/reports/'
      path: '/reports'
      fullPath: '/$companySlug/reports/'
      preLoaderRoute: typeof AuthenticatedCompanySlugReportsIndexRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/marketplace/': {
      id: '/_authenticated/$companySlug/marketplace/'
      path: '/marketplace'
      fullPath: '/$companySlug/marketplace/'
      preLoaderRoute: typeof AuthenticatedCompanySlugMarketplaceIndexRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/fleet-tracking/': {
      id: '/_authenticated/$companySlug/fleet-tracking/'
      path: '/fleet-tracking'
      fullPath: '/$companySlug/fleet-tracking/'
      preLoaderRoute: typeof AuthenticatedCompanySlugFleetTrackingIndexRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/fleet-allocation/': {
      id: '/_authenticated/$companySlug/fleet-allocation/'
      path: '/fleet-allocation'
      fullPath: '/$companySlug/fleet-allocation/'
      preLoaderRoute: typeof AuthenticatedCompanySlugFleetAllocationIndexRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/dashboard/': {
      id: '/_authenticated/$companySlug/dashboard/'
      path: '/dashboard'
      fullPath: '/$companySlug/dashboard/'
      preLoaderRoute: typeof AuthenticatedCompanySlugDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/charging-infrastructure/': {
      id: '/_authenticated/$companySlug/charging-infrastructure/'
      path: '/charging-infrastructure'
      fullPath: '/$companySlug/charging-infrastructure/'
      preLoaderRoute: typeof AuthenticatedCompanySlugChargingInfrastructureIndexRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/administration/': {
      id: '/_authenticated/$companySlug/administration/'
      path: '/administration'
      fullPath: '/$companySlug/administration/'
      preLoaderRoute: typeof AuthenticatedCompanySlugAdministrationIndexRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/vehicles/create': {
      id: '/_authenticated/$companySlug/vehicles/create'
      path: '/vehicles/create'
      fullPath: '/$companySlug/vehicles/create'
      preLoaderRoute: typeof AuthenticatedCompanySlugVehiclesCreateRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/users/create': {
      id: '/_authenticated/$companySlug/users/create'
      path: '/users/create'
      fullPath: '/$companySlug/users/create'
      preLoaderRoute: typeof AuthenticatedCompanySlugUsersCreateRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/route-planning/import': {
      id: '/_authenticated/$companySlug/route-planning/import'
      path: '/route-planning/import'
      fullPath: '/$companySlug/route-planning/import'
      preLoaderRoute: typeof AuthenticatedCompanySlugRoutePlanningImportRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/route-planning/assignment': {
      id: '/_authenticated/$companySlug/route-planning/assignment'
      path: '/route-planning/assignment'
      fullPath: '/$companySlug/route-planning/assignment'
      preLoaderRoute: typeof AuthenticatedCompanySlugRoutePlanningAssignmentRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/reports/import': {
      id: '/_authenticated/$companySlug/reports/import'
      path: '/reports/import'
      fullPath: '/$companySlug/reports/import'
      preLoaderRoute: typeof AuthenticatedCompanySlugReportsImportRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/notification-center/$alertId': {
      id: '/_authenticated/$companySlug/notification-center/$alertId'
      path: '/$alertId'
      fullPath: '/$companySlug/notification-center/$alertId'
      preLoaderRoute: typeof AuthenticatedCompanySlugNotificationCenterAlertIdRouteImport
      parentRoute: typeof AuthenticatedCompanySlugNotificationCenterRouteRoute
    }
    '/_authenticated/$companySlug/fleets/$fleetId': {
      id: '/_authenticated/$companySlug/fleets/$fleetId'
      path: '/fleets/$fleetId'
      fullPath: '/$companySlug/fleets/$fleetId'
      preLoaderRoute: typeof AuthenticatedCompanySlugFleetsFleetIdRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/users/_overview': {
      id: '/_authenticated/$companySlug/users/_overview'
      path: '/users'
      fullPath: '/$companySlug/users'
      preLoaderRoute: typeof AuthenticatedCompanySlugUsersOverviewRouteRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/vehicles/$vin/': {
      id: '/_authenticated/$companySlug/vehicles/$vin/'
      path: '/vehicles/$vin'
      fullPath: '/$companySlug/vehicles/$vin/'
      preLoaderRoute: typeof AuthenticatedCompanySlugVehiclesVinIndexRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/vehicles/$vin/update': {
      id: '/_authenticated/$companySlug/vehicles/$vin/update'
      path: '/vehicles/$vin/update'
      fullPath: '/$companySlug/vehicles/$vin/update'
      preLoaderRoute: typeof AuthenticatedCompanySlugVehiclesVinUpdateRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/users/_overview/$userId': {
      id: '/_authenticated/$companySlug/users/_overview/$userId'
      path: '/$userId'
      fullPath: '/$companySlug/users/$userId'
      preLoaderRoute: typeof AuthenticatedCompanySlugUsersOverviewUserIdRouteImport
      parentRoute: typeof AuthenticatedCompanySlugUsersOverviewRouteRoute
    }
    '/_authenticated/$companySlug/users/$userId/edit': {
      id: '/_authenticated/$companySlug/users/$userId/edit'
      path: '/users/$userId/edit'
      fullPath: '/$companySlug/users/$userId/edit'
      preLoaderRoute: typeof AuthenticatedCompanySlugUsersUserIdEditRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/reports/edit/$reportId': {
      id: '/_authenticated/$companySlug/reports/edit/$reportId'
      path: '/reports/edit/$reportId'
      fullPath: '/$companySlug/reports/edit/$reportId'
      preLoaderRoute: typeof AuthenticatedCompanySlugReportsEditReportIdRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
    '/_authenticated/$companySlug/charging-infrastructure/$siteId/terminals/$chargeTerminalId': {
      id: '/_authenticated/$companySlug/charging-infrastructure/$siteId/terminals/$chargeTerminalId'
      path: '/charging-infrastructure/$siteId/terminals/$chargeTerminalId'
      fullPath: '/$companySlug/charging-infrastructure/$siteId/terminals/$chargeTerminalId'
      preLoaderRoute: typeof AuthenticatedCompanySlugChargingInfrastructureSiteIdTerminalsChargeTerminalIdRouteImport
      parentRoute: typeof AuthenticatedCompanySlugRoute
    }
  }
}

interface AuthenticatedCompanySlugNotificationCenterRouteRouteChildren {
  AuthenticatedCompanySlugNotificationCenterAlertIdRoute: typeof AuthenticatedCompanySlugNotificationCenterAlertIdRoute
}

const AuthenticatedCompanySlugNotificationCenterRouteRouteChildren: AuthenticatedCompanySlugNotificationCenterRouteRouteChildren =
  {
    AuthenticatedCompanySlugNotificationCenterAlertIdRoute:
      AuthenticatedCompanySlugNotificationCenterAlertIdRoute,
  }

const AuthenticatedCompanySlugNotificationCenterRouteRouteWithChildren =
  AuthenticatedCompanySlugNotificationCenterRouteRoute._addFileChildren(
    AuthenticatedCompanySlugNotificationCenterRouteRouteChildren,
  )

interface AuthenticatedCompanySlugUsersOverviewRouteRouteChildren {
  AuthenticatedCompanySlugUsersOverviewUserIdRoute: typeof AuthenticatedCompanySlugUsersOverviewUserIdRoute
}

const AuthenticatedCompanySlugUsersOverviewRouteRouteChildren: AuthenticatedCompanySlugUsersOverviewRouteRouteChildren =
  {
    AuthenticatedCompanySlugUsersOverviewUserIdRoute:
      AuthenticatedCompanySlugUsersOverviewUserIdRoute,
  }

const AuthenticatedCompanySlugUsersOverviewRouteRouteWithChildren =
  AuthenticatedCompanySlugUsersOverviewRouteRoute._addFileChildren(
    AuthenticatedCompanySlugUsersOverviewRouteRouteChildren,
  )

interface AuthenticatedCompanySlugRouteChildren {
  AuthenticatedCompanySlugNotificationCenterRouteRoute: typeof AuthenticatedCompanySlugNotificationCenterRouteRouteWithChildren
  AuthenticatedCompanySlugUserSettingsRoute: typeof AuthenticatedCompanySlugUserSettingsRoute
  AuthenticatedCompanySlugUsersOverviewRouteRoute: typeof AuthenticatedCompanySlugUsersOverviewRouteRouteWithChildren
  AuthenticatedCompanySlugFleetsFleetIdRoute: typeof AuthenticatedCompanySlugFleetsFleetIdRoute
  AuthenticatedCompanySlugReportsImportRoute: typeof AuthenticatedCompanySlugReportsImportRoute
  AuthenticatedCompanySlugRoutePlanningAssignmentRoute: typeof AuthenticatedCompanySlugRoutePlanningAssignmentRoute
  AuthenticatedCompanySlugRoutePlanningImportRoute: typeof AuthenticatedCompanySlugRoutePlanningImportRoute
  AuthenticatedCompanySlugUsersCreateRoute: typeof AuthenticatedCompanySlugUsersCreateRoute
  AuthenticatedCompanySlugVehiclesCreateRoute: typeof AuthenticatedCompanySlugVehiclesCreateRoute
  AuthenticatedCompanySlugAdministrationIndexRoute: typeof AuthenticatedCompanySlugAdministrationIndexRoute
  AuthenticatedCompanySlugChargingInfrastructureIndexRoute: typeof AuthenticatedCompanySlugChargingInfrastructureIndexRoute
  AuthenticatedCompanySlugDashboardIndexRoute: typeof AuthenticatedCompanySlugDashboardIndexRoute
  AuthenticatedCompanySlugFleetAllocationIndexRoute: typeof AuthenticatedCompanySlugFleetAllocationIndexRoute
  AuthenticatedCompanySlugFleetTrackingIndexRoute: typeof AuthenticatedCompanySlugFleetTrackingIndexRoute
  AuthenticatedCompanySlugMarketplaceIndexRoute: typeof AuthenticatedCompanySlugMarketplaceIndexRoute
  AuthenticatedCompanySlugReportsIndexRoute: typeof AuthenticatedCompanySlugReportsIndexRoute
  AuthenticatedCompanySlugRoutePlanningIndexRoute: typeof AuthenticatedCompanySlugRoutePlanningIndexRoute
  AuthenticatedCompanySlugUsersOldIndexRoute: typeof AuthenticatedCompanySlugUsersOldIndexRoute
  AuthenticatedCompanySlugVehiclesIndexRoute: typeof AuthenticatedCompanySlugVehiclesIndexRoute
  AuthenticatedCompanySlugReportsEditReportIdRoute: typeof AuthenticatedCompanySlugReportsEditReportIdRoute
  AuthenticatedCompanySlugUsersUserIdEditRoute: typeof AuthenticatedCompanySlugUsersUserIdEditRoute
  AuthenticatedCompanySlugVehiclesVinUpdateRoute: typeof AuthenticatedCompanySlugVehiclesVinUpdateRoute
  AuthenticatedCompanySlugVehiclesVinIndexRoute: typeof AuthenticatedCompanySlugVehiclesVinIndexRoute
  AuthenticatedCompanySlugChargingInfrastructureSiteIdTerminalsChargeTerminalIdRoute: typeof AuthenticatedCompanySlugChargingInfrastructureSiteIdTerminalsChargeTerminalIdRoute
}

const AuthenticatedCompanySlugRouteChildren: AuthenticatedCompanySlugRouteChildren =
  {
    AuthenticatedCompanySlugNotificationCenterRouteRoute:
      AuthenticatedCompanySlugNotificationCenterRouteRouteWithChildren,
    AuthenticatedCompanySlugUserSettingsRoute:
      AuthenticatedCompanySlugUserSettingsRoute,
    AuthenticatedCompanySlugUsersOverviewRouteRoute:
      AuthenticatedCompanySlugUsersOverviewRouteRouteWithChildren,
    AuthenticatedCompanySlugFleetsFleetIdRoute:
      AuthenticatedCompanySlugFleetsFleetIdRoute,
    AuthenticatedCompanySlugReportsImportRoute:
      AuthenticatedCompanySlugReportsImportRoute,
    AuthenticatedCompanySlugRoutePlanningAssignmentRoute:
      AuthenticatedCompanySlugRoutePlanningAssignmentRoute,
    AuthenticatedCompanySlugRoutePlanningImportRoute:
      AuthenticatedCompanySlugRoutePlanningImportRoute,
    AuthenticatedCompanySlugUsersCreateRoute:
      AuthenticatedCompanySlugUsersCreateRoute,
    AuthenticatedCompanySlugVehiclesCreateRoute:
      AuthenticatedCompanySlugVehiclesCreateRoute,
    AuthenticatedCompanySlugAdministrationIndexRoute:
      AuthenticatedCompanySlugAdministrationIndexRoute,
    AuthenticatedCompanySlugChargingInfrastructureIndexRoute:
      AuthenticatedCompanySlugChargingInfrastructureIndexRoute,
    AuthenticatedCompanySlugDashboardIndexRoute:
      AuthenticatedCompanySlugDashboardIndexRoute,
    AuthenticatedCompanySlugFleetAllocationIndexRoute:
      AuthenticatedCompanySlugFleetAllocationIndexRoute,
    AuthenticatedCompanySlugFleetTrackingIndexRoute:
      AuthenticatedCompanySlugFleetTrackingIndexRoute,
    AuthenticatedCompanySlugMarketplaceIndexRoute:
      AuthenticatedCompanySlugMarketplaceIndexRoute,
    AuthenticatedCompanySlugReportsIndexRoute:
      AuthenticatedCompanySlugReportsIndexRoute,
    AuthenticatedCompanySlugRoutePlanningIndexRoute:
      AuthenticatedCompanySlugRoutePlanningIndexRoute,
    AuthenticatedCompanySlugUsersOldIndexRoute:
      AuthenticatedCompanySlugUsersOldIndexRoute,
    AuthenticatedCompanySlugVehiclesIndexRoute:
      AuthenticatedCompanySlugVehiclesIndexRoute,
    AuthenticatedCompanySlugReportsEditReportIdRoute:
      AuthenticatedCompanySlugReportsEditReportIdRoute,
    AuthenticatedCompanySlugUsersUserIdEditRoute:
      AuthenticatedCompanySlugUsersUserIdEditRoute,
    AuthenticatedCompanySlugVehiclesVinUpdateRoute:
      AuthenticatedCompanySlugVehiclesVinUpdateRoute,
    AuthenticatedCompanySlugVehiclesVinIndexRoute:
      AuthenticatedCompanySlugVehiclesVinIndexRoute,
    AuthenticatedCompanySlugChargingInfrastructureSiteIdTerminalsChargeTerminalIdRoute:
      AuthenticatedCompanySlugChargingInfrastructureSiteIdTerminalsChargeTerminalIdRoute,
  }

const AuthenticatedCompanySlugRouteWithChildren =
  AuthenticatedCompanySlugRoute._addFileChildren(
    AuthenticatedCompanySlugRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedCompanySlugRoute: typeof AuthenticatedCompanySlugRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCompanySlugRoute: AuthenticatedCompanySlugRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ActivateRoute: ActivateRoute,
  ForbiddenRoute: ForbiddenRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  NotFoundRoute: NotFoundRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ResetPasswordExpiredRoute: ResetPasswordExpiredRoute,
  ResetPasswordSuccessfulRoute: ResetPasswordSuccessfulRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
